import { Box, Typography } from '@mui/material'
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'
import { ErrorComponent } from '@/components/ErrorComponent'
import { LoadingComponent } from '@/components/LoadingComponent'
import {
	EntityKeys as allEntityKeys,
	getEntityConfig,
	isEntityKey as isKnownEntityKey,
} from '@/generated/entity-config'
import { getEntityLabel } from '@/lib/entity-route-i18n'
import { EntitySearchSchema } from '@/lib/entity-search'

const listEntityKeys = allEntityKeys.filter(
	(key) => getEntityConfig(key).kind === 'entity',
)

function isRoutableEntityKey(entity: string) {
	return isKnownEntityKey(entity) && getEntityConfig(entity).kind === 'entity'
}

export const Route = createFileRoute('/_authenticated/$entity')({
	validateSearch: EntitySearchSchema,
	search: {},
	staticData: {
		breadcrumb: ({ params }) => ({
			label: getEntityLabel(String(params.entity ?? '')),
		}),
	},
	component: EntityRoute,
	beforeLoad({ params }) {
		const entity = String(params.entity ?? '')
		if (!isRoutableEntityKey(entity)) {
			throw notFound({})
		}
	},
	notFoundComponent: EntityNotFound,
	errorComponent: ErrorComponent,
	pendingComponent: LoadingComponent,
})

export function EntityNotFound() {
	const { entity } = Route.useParams()
	return (
		<Box p={2}>
			<Typography variant="h6" color="error">
				Entity "{entity}" is not supported.
			</Typography>
			{import.meta.env.DEV && (
				<Typography>Supported entities: {listEntityKeys.join(', ')}</Typography>
			)}
		</Box>
	)
}

export function EntityRoute() {
	return <Outlet />
}
